// Dependencies
import React, { FunctionComponent } from "react";

// Types
import { PerformanceEssayAvarageNoteProps } from "./performance-essay-avarage-note.types";

// Styles
import { Container, SectionTitle, Divider } from "./performance-essay-avarage-note.styles";

// Components
import { Spacing } from "component-library/utilities/spacing";

export const PerformanceEssayAvarageNote: FunctionComponent<PerformanceEssayAvarageNoteProps> = ({ sectionTitle, graphicComposition }) => {
    return (
        <Container>
            <SectionTitle>{sectionTitle}</SectionTitle>

            <Spacing direction="vertical" size={16} />

            <Divider />

            <Spacing direction="vertical" size={16} />

            {graphicComposition}
        </Container>
    );
};
